import { useMemo } from 'react';
import { NEW_LINE_MARKER } from '@shared/lib/localize';

/**
 * Default text-cell renderer for FSD Table. Splits multi-line values
 * (delimited by `NEW_LINE_MARKER`) into stacked `<div>`s and joins
 * array values with the legacy `, %%%` glue. Pure presentational —
 * no Redux, no router, no theme reads, so it lifts cleanly out of
 * `_legacy/components/Shared/Table/widgets/Cell/CellContent/` into
 * the FSD cells layer with no behaviour changes.
 */
const SUBTEXT_STYLE = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
  fontSize: 12,
  lineHeight: 1.35,
  color: 'var(--qhs-text-3)',
};

/**
 * @param {string} [subtext] Optional second, muted line under the value
 *   (a description under a name): one line, cut with an ellipsis, the
 *   full text on hover.
 */
const CellSimpleText = ({ value, subtext }) => {
  const text = useMemo(
    () =>
      value
        ? (Array.isArray(value) ? (value.length === 0 ? '-' : value.join(', %%%')) : value).split(
            NEW_LINE_MARKER
          )
        : '-',
    [value]
  );

  return (
    <div
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
      }}
    >
      {text.length <= 1 ? text : text.map(dataLine => <div key={dataLine}>{dataLine}</div>)}
      {subtext ? (
        <div style={SUBTEXT_STYLE} title={subtext}>
          {subtext}
        </div>
      ) : null}
    </div>
  );
};

export default CellSimpleText;
